module.exports = __webpack_public_path__ + "static/media/logo-black-friday-black.76cca46e.png";